import React from 'react'
import { oneOf, bool, number } from 'prop-types'
import { Container, Inner, PulsingInner } from './components/index.styles'

const propTypes = {
  variant: oneOf(['PENDING', 'REJECTED', 'INFO', 'PAYMENT']).isRequired,
  animate: bool,
  size: number,
}

const PulsingCircle = ({ size = 16, variant, animate = false, ...others }) => {
  return (
    <Container {...others}>
      {animate ? (
        <PulsingInner size={size} variant={variant} />
      ) : (
        <Inner size={size} variant={variant} />
      )}
    </Container>
  )
}

PulsingCircle.propTypes = propTypes

export { PulsingCircle }
